export default __webpack_public_path__ + "static/media/movieIcon.13e20a0d.jpg";